import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Availability } from 'infrastructure/classes/availability';

import s from './styles.module.scss';

import type { ISmsCampaign } from 'infrastructure/interfaces';

interface IProps {
  data: ISmsCampaign;
}

const ContactAvailabilityCol: React.FC<IProps> = (props) => {
  const { data } = props;

  const { availabilities } = data;

  const { timezone } = data.patient;

  const { t } = useTranslation();

  const [now, setNow] = useState(new Date());

  const anytime = !availabilities.length;

  const isAvailable = useMemo(() => {
    return Availability.isAvailable(
      availabilities.map(
        (el, i) =>
          new Availability({
            day: el.day,
            startTime: el.startTime,
            endTime: el.endTime,
            guid: `${i}`,
            patientGuid: `${i}`,
          }),
      ),
      timezone,
    );
  }, [availabilities, now, timezone]);

  const availableText = isAvailable
    ? t('labels.available')
    : t('labels.notAvailable');

  const statusText = anytime ? t('labels.anytime') : availableText;

  const timeClassNames = classNames(s.time, {
    [s.green]: isAvailable || anytime,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  return <span className={timeClassNames}>{statusText}</span>;
};

export default ContactAvailabilityCol;
